import React from "react";

/**
 * @component LabelsIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <LabelsIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const LabelsIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="LabelsIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        d="M17 2a3 3 0 013 3v17l-8-4-8 4V5a3 3 0 013-3h10zm0 2H7a1 1 0 00-.993.883L6 5v13.764l6-3 6 3V5a1 1 0 00-.883-.993L17 4z"
        fillRule="evenodd"
      />
    </svg>
  )
);
LabelsIcon.displayName = "LabelsIcon";
export default LabelsIcon;
